import React from "react";
import { colors2, UI_BODY_SEMIBOLD_SM } from "oolib";
import styled from "styled-components";

// A filled-segment control (a.k.a. segmented control): a small, bordered group
// of mutually-exclusive options where the active segment is filled. This is NOT
// a tab bar — for page/section navigation use oolib's TabBar / TabBarV2, which
// are heavier nav components. Consolidated from the duplicated segmented-control
// implementations across the reports widget config forms and the number-range
// filter editors.

const StyledSegmentedControl = styled.div`
  display: flex;
  border: 1px solid ${colors2.grey10};
  border-radius: 8px;
  overflow: hidden;
`;

const StyledSegment = styled.button`
  flex: 1;
  padding: 6px 14px;
  border: none;
  font-family: inherit;
  background: ${({ $active }) => ($active ? colors2.secondaryContainer : "transparent")};
  color: ${({ $active }) => ($active ? colors2.onSecondary : colors2.grey60)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:not(:last-child) {
    border-right: 1px solid ${colors2.grey10};
  }

  &:hover {
    background: ${({ $active }) =>
    $active ? colors2.secondaryContainer : colors2.grey5};
  }
`;

/**
 * SegmentedControl
 *
 * @param {Array<{ display: string, value: string }>} options - the segments to render
 * @param {string} value - the currently selected option value
 * @param {Function} onChange - (value) => void, called with the clicked segment's value
 * @param {string} [className] - passed to the container (for layout overrides)
 * @param {Object} [style] - passed to the container (e.g. margins at the call site)
 */
export const SegmentedControl = ({ options = [], value, onChange, className, style }) => (
  <StyledSegmentedControl className={className} style={style}>
    {options.map((opt) => (
      <StyledSegment
        key={opt.value}
        $active={value === opt.value}
        onClick={() => onChange(opt.value)}
      >
        <UI_BODY_SEMIBOLD_SM>
          {opt.display}
        </UI_BODY_SEMIBOLD_SM>
      </StyledSegment>
    ))}
  </StyledSegmentedControl>
);
